



























import Vue from 'vue'
export default Vue.extend({
    name: 'LocaleChanger',
    props: ['langs'],
    computed: {
        largeScreen() {
            return !this.$vuetify.breakpoint.mobile
        },
    },
    methods: {
        setLocale: function(value: string) {
            this.$i18n.locale = value
        },
    },
})
